import { useMemo } from 'react'
import { useCurrentUser } from '@/features/profile/hooks/useCurrentUser'
import type { AccountPaymentType } from '../types'

interface UseAccountTypeResult {
  accountType: AccountPaymentType
  isFreeUser: boolean
  isPaidUser: boolean
  isLoading: boolean
}

/**
 * Hook to check user's account type (FREE or PAID)
 * Returns account type and convenience boolean flags
 */
export function useAccountType(): UseAccountTypeResult {
  const { user: userProfile, isPending } = useCurrentUser()

  return useMemo(() => {
    // Still loading until the profile query has data (or failed)
    const isLoading = isPending

    // Get accountType from profile metadata, default to FREE
    const accountType: AccountPaymentType =
      userProfile?.profileMetadata?.accountType ?? 'FREE'

    return {
      accountType,
      isFreeUser: accountType === 'FREE',
      isPaidUser: accountType === 'PAID',
      isLoading,
    }
  }, [userProfile, isPending])
}
